import React from "react";
import { Link } from "react-router-dom";
// image import
import errorIllustration from "../../../assets/images/shapes/error-illustration.png";


const Error = () => {

  return (
    <>
      {/* ===============  error area start =============== */}
      <div className="error-wrapper mt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="error-content text-center">
                <div className="error-illustration">
                  <img src={errorIllustration} alt="" className="img-fluid" />
                </div>
                <h3>Page introuvable</h3>
                <div className="error-back-btn">
                  <Link
                    to={"/"}
                    className="primary-btn-fill">
                    Revenir à la page d'accueil
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===============  error area end =============== */}
    </>
  );
}

export default Error;
